import React from 'react';
import { useState, useEffect } from 'react';
import Header from '../components/ui/Header';
import SearchAndFilters from '../components/ui/SearchAndFilters';
import ResourceList from '../components/ui/ResourceList';
import { openDialogWithCallback } from '../utils/dialogHandler';
import { DialogEventType } from '../utils/dialog';
import { initBroadcast } from '../utils/broadcast';
// Các enum mẫu tương tự code của khách hàng
var DialogErrorCode;
(function (DialogErrorCode) {
    DialogErrorCode[DialogErrorCode["Closed"] = 12006] = "Closed";
})(DialogErrorCode || (DialogErrorCode = {}));
var OfficeDialogMessageType;
(function (OfficeDialogMessageType) {
    OfficeDialogMessageType["SavedReservations"] = "SavedReservations";
    OfficeDialogMessageType["CloseDialog"] = "CloseDialog";
    OfficeDialogMessageType["UpdateAttendees"] = "UpdateAttendees";
})(OfficeDialogMessageType || (OfficeDialogMessageType = {}));
const Home = () => {
    const [showAllResources, setShowAllResources] = useState(true);
    const [resources, setResources] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [dialogStatus, setDialogStatus] = useState('idle');
    const [currentDialogHandler, setCurrentDialogHandler] = useState(null);
    const [broadcastInitialized, setBroadcastInitialized] = useState(false);
    // Initialize BroadcastChannel
    useEffect(() => {
        if (!broadcastInitialized) {
            initBroadcast((data) => {
                console.log('Home component nhận data từ dialog:', data);
            });
            setBroadcastInitialized(true);
        }
    }, [broadcastInitialized]);
    // Mock loading resources with useEffect
    useEffect(() => {
        // Simulate API call
        const fetchResources = () => {
            setLoading(true);
            // Mock data 
            const mockResources = [
                {
                    id: 1,
                    name: 'AAR Room',
                    capacity: { current: 8, total: 10 },
                    features: ['building', 'people', 'computer'],
                    timeSlots: [{ start: 25, end: 50, color: 'bg-blue-200' }],
                    status: 'reserved',
                    available: false
                },
                {
                    id: 2,
                    name: 'AAR Room',
                    capacity: { current: 8, total: 10 },
                    features: ['building', 'people', 'computer'],
                    timeSlots: [{ start: 50, end: 70, color: 'bg-blue-200' }],
                    status: 'reserved',
                    available: false
                },
                {
                    id: 3,
                    name: 'AAR Desk1',
                    capacity: { current: 6, total: 10 },
                    features: ['building', 'computer'],
                    timeSlots: [
                        { start: 0, end: 10, color: 'bg-green-200' },
                        { start: 50, end: 70, color: 'bg-pink-200' }
                    ],
                    status: 'available',
                    available: true
                }
            ];
            // Simulate delay
            setTimeout(() => {
                setResources(mockResources);
                setLoading(false);
            }, 500);
        };
        fetchResources();
    }, []);
    const handleLoadMore = () => {
        setPage(prevPage => prevPage + 1);
        // In a real app, this would fetch more resources based on the page
        console.log('Loading more resources...');
    };
    // Custom callback handler tương tự với ví dụ của khách hàng
    const handleDialogCallback = (dialog) => {
        if (dialog) {
            setCurrentDialogHandler(dialog);
            // Set up event handler (tương tự cách bạn đã viết)
            dialog.addEventHandler(DialogEventType.DialogEventReceived, (args) => {
                if (args.error === DialogErrorCode.Closed) {
                    console.log('Dialog was closed by user');
                    // Xử lý khi người dùng đóng dialog
                    setCurrentDialogHandler(null);
                    setDialogStatus('idle');
                }
            });
            // Set up message handler
            dialog.addEventHandler(DialogEventType.DialogMessageReceived, (args) => {
                if (args.message) {
                    try {
                        const message = JSON.parse(args.message);
                        console.log('Received message:', message);
                        switch (message.MessageType) {
                            case OfficeDialogMessageType.SavedReservations:
                                console.log('Handle saved reservations');
                                // Xử lý saved reservations
                                break;
                            case OfficeDialogMessageType.CloseDialog:
                                console.log('Closing dialog from message');
                                dialog.close();
                                setCurrentDialogHandler(null);
                                setDialogStatus('idle');
                                break;
                            case OfficeDialogMessageType.UpdateAttendees:
                                console.log('Handle update attendees');
                                // Xử lý update attendees
                                break;
                            default:
                                console.log('Unknown message type:', message.MessageType);
                        }
                    }
                    catch (error) {
                        console.error('Error handling message:', error);
                    }
                }
            });
        }
    };
    // Function to open the floorplan dialog với custom callback
    const handleOpenFloorplanWithCustomCallback = () => {
        setDialogStatus('loading');
        // Get the URL for the floorplan
        const baseUrl = window.location.origin;
        const floorplanUrl = `${baseUrl}/floorplan.html?dialog=true`;
        // Cấu hình callback options
        const callbackOptions = {
            // Được gọi ngay sau khi dialog mở thành công
            onDialogOpen: (dialog) => {
                handleDialogCallback(dialog);
                // // Gửi data test lên dialog sau khi mở
                // setTimeout(() => {
                //   console.log('🚀 Gửi data test lên floorplan dialog...');
                //   // Gửi thông tin emails đã chọn
                //   sendData({
                //     type: 'selectedEmails',
                //     data: ['john@example.com', 'jane@example.com', 'bob@example.com']
                //   });
                //   // Gửi thông tin meeting
                //   setTimeout(() => {
                //     sendData({
                //       type: 'meetingInfo',
                //       data: {
                //         title: 'Team Meeting',
                //         duration: 60,
                //         attendees: 5,
                //         room: 'Conference Room A'
                //       }
                //     });
                //   }, 1000);
                //   // Gửi user preferences
                //   setTimeout(() => {
                //     sendData({
                //       type: 'userPreferences',
                //       data: {
                //         theme: 'dark',
                //         language: 'vi',
                //         notifications: true,
                //         defaultFloor: '2nd Floor'
                //       }
                //     });
                //   }, 2000);
                // }, 500);
            },
            // Callback khi dialog đóng
            onDialogClosed: () => {
                console.log('Dialog was closed');
                setCurrentDialogHandler(null);
                setDialogStatus('idle');
            }
        };
        // Mở dialog với custom callback
        openDialogWithCallback(floorplanUrl, {
            width: 86,
            height: 86,
            callbackOptions
        }).then(dialog => {
            console.log('Dialog opened successfully');
        }).catch(error => {
            console.error('Error opening dialog:', error);
            setDialogStatus('error');
            // Reset status after 3 seconds
            setTimeout(() => {
                setDialogStatus('idle');
            }, 3000);
        });
    };
    // Filter resources if showAllResources is false
    const filteredResources = showAllResources
        ? resources
        : resources.filter(resource => resource.available);
    return (React.createElement("div", { className: "p-2" },
        React.createElement(Header, null),
        React.createElement("div", { className: "mt-2" },
            React.createElement(SearchAndFilters, { showAllResources: showAllResources, setShowAllResources: setShowAllResources }),
            loading ? (React.createElement("div", { className: "flex justify-center items-center h-32 bg-white" },
                React.createElement("div", { className: "animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" }))) : (React.createElement(ResourceList, { resources: filteredResources, onLoadMore: handleLoadMore })))));
};
export default Home;
